module.exports = __webpack_public_path__ + "img/10.b0444876.png";